import {defineStore} from 'pinia'
import type {OutputZone, OutputZoneChannelData} from "~/models"

export const useChannelsStore = defineStore('channels', {
    state: () => ({
        zones: [] as OutputZone[],
    }),
    actions: {
        async load() {
            this.zones = await useApi().getFlyZones()
        },
    },
})